import { useEffect } from "react";

// Metadata manager: document title, meta description, Open Graph. No analytics.
export function Seo({ title, description }) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} — Nofina Movie`
      : "Nofina Movie — Langganan Digital Lebih Mudah";
    document.title = fullTitle;

    const setMeta = (attr, key, content) => {
      if (!content) return;
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
  }, [title, description]);

  return null;
}
